import { Router, NavigationEnd } from '@angular/router';
import { JqueryHelperService } from './jquery-helper.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoadAdsAction } from './container/adds/store/ad.actions';
import { AppState } from './models/app.state';
import { Store } from '@ngrx/store';
import { LoadProductsAction } from './actions/products.actions';
import { LoadWindowsAction } from './actions/windows.actions';
import { LoadCategoriesAction } from './actions/category.actions';
import { LocationService } from "./shared/geolocation.service";
import { CookieService } from './shared/cookie.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, OnDestroy {


  title = 'app';
  // scrollPosition;

  // private initializeSubscription: Subscription;

  constructor(private translate: TranslateService, private store: Store<AppState>,
    private locationService: LocationService, private jQueryService: JqueryHelperService,
    private cookiesService: CookieService) {
    translate.setDefaultLang('it');
    translate.use('it');

    this.cookiesService.updateCookiesLang();

    this.store.dispatch(new LoadProductsAction());
    this.store.dispatch(new LoadWindowsAction());
    this.store.dispatch(new LoadAdsAction());
    this.store.dispatch(new LoadCategoriesAction());
    this.jQueryService.saveScrollPosition();
  }

  ngOnInit(): void {
    this.getLocation();
    // this.jQueryService.setScrollPosition();


    // this.initializeSubscription = this.ccService.initialize$.subscribe(
    //   (event: NgcInitializeEvent) => {
    //     // you can use this.ccService.getConfig() to do stuff...
    //   });
  }

  getLocation() {
    if (navigator.geolocation) {
      console.log('NAVIGATOR');
      navigator.geolocation.getCurrentPosition(position => {
        console.log('CURRENT POSITION: ', position.coords);
        this.locationService.userCoords = position.coords;
        // this.jQueryService.initDistanceSlider('desktop');
        // this.jQueryService.initDistanceSlider('mobile');
      });

    }
  }



  ngOnDestroy(): void {
    // this.initializeSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/app.component.ts